<div *ngIf="pay && configSetupData && loaded" class="payline-table-container">
  <div *ngFor="let payline of paylines">
    <div class="d-flex">
      <div class="justify-content-start labor-allocation-header">
        <strong
          >{{ pay.EmployeeLastName }}, {{ pay.EmployeeFirstName }} -
          {{ pay.EmployeeNumber }}</strong
        >
      </div>
      <div *ngIf="payrollMgmt.periodEndDisplay(payroll, true) == 'Multiple'" class="ms-5">
        Period End Date: {{ payline.PeriodEndOverride || pay.PeriodEnd | date: 'MM/dd/yyyy' }}
      </div>
    </div>
    <!-- user story 7224 -->
    <table
      *ngFor="let allocation of allocations[payline.PaylineId]"
      class="table table-sm fixed-width mb-0 h-100">
      <thead>
        <tr>
          <th></th>
          <th class="text-start">Earn Name</th>
          <th class="text-end">Rate/Amount</th>
          <th class="text-end">Hours</th>
          <th class="text-end border-right-grey">Amount</th>
          <th class="text-start">Tax Name</th>
          <th class="text-end border-right-grey">Current Amount</th>
          <th class="text-start">Ded Name</th>
          <th class="text-end">Current Amount</th>
        </tr>
      </thead>
      <tbody>
        <!-- details row -->
        <tr class="border-bottom-grey">
          <td *ngIf="allocation.name != '__TOTAL__'" class="border-right-grey overflow-hidden">
            <div class="allocation-name">
              {{ LaborAllocationType }} {{ allocation.name ?? 'None' }}
            </div>
            <div>{{ allocation.allocation.ResultPercentage | number: '1.2-2' }}%</div>
          </td>
          <td *ngIf="allocation.name == '__TOTAL__'" class="border-right-grey">
            <div>Total</div>
            <div></div>
          </td>
          <!--
            bug 7857. display 0 if temporary/permanent amounts are 0.
            do not render anything if amount is null. passing null to
            the number pipe returns nothing.
          -->
          <!-- earnings -->
          <td>
            <div *ngFor="let earn of allocation.filteredEarnings">
              <span
                [ngClass]="{
                  'fst-italic':
                    earn.TemporaryRateAmount != null &&
                    earn.TemporaryRateAmount != earn.PermanentRateAmount
                }">
                {{ laborAllocations.getEarningName(earn.EarningId) }}
              </span>
            </div>
          </td>
          <td class="text-end">
            <div *ngFor="let earn of allocation.filteredEarnings">
              &nbsp;
              <span
                [ngClass]="{
                  'fst-italic':
                    earn.TemporaryRateAmount != null &&
                    earn.TemporaryRateAmount != earn.PermanentRateAmount
                }">
                {{ allocation.calculateRate(earn) | number: '1.2-2' }}
              </span>
            </div>
          </td>
          <td class="text-end">
            <div *ngFor="let earn of allocation.filteredEarnings">
              &nbsp;
              {{ allocation.calculateHours(earn) | number: '1.2-2' }}
            </div>
          </td>
          <td class="text-end border-right-grey">
            <div
              *ngFor="let earn of allocation.filteredEarnings"
              [ngClass]="{
                'fst-italic':
                  earn.TemporaryRateAmount != null &&
                  earn.TemporaryRateAmount != earn.PermanentRateAmount
              }">
              &nbsp;
              {{ allocation.calculateAmount(earn) | number: '1.2-2' }}
            </div>
          </td>
          <!-- taxes -->
          <td>
            <div *ngFor="let tax of allocation.payline.Taxes">
              &nbsp;
              <span [ngClass]="{ 'fst-italic': tax.TemporaryAmount != null }">
                {{ tax.TaxCode }}
              </span>
            </div>
          </td>
          <td class="text-end border-right-grey">
            <div *ngFor="let tax of allocation.payline.Taxes">
              &nbsp;
              <span [ngClass]="{ 'fst-italic': tax.TemporaryAmount != null }">
                {{ allocation.calculateTax(tax) | number: '1.2-2' }}
              </span>
            </div>
          </td>
          <!-- deductions -->
          <td>
            <div *ngFor="let ded of allocation.payline.Deductions">
              <span
                [ngClass]="{
                  'fst-italic':
                    (ded.TemporaryAmount != null && ded.TemporaryAmount != ded.PermanentAmount) ||
                    (ded.TemporaryRate != null && ded.TemporaryRate != ded.PermanentRate)
                }">
                {{ laborAllocations.getDeductionName(ded.DeductionCode) }}
              </span>
            </div>
          </td>
          <td class="text-end">
            <div *ngFor="let deduction of allocation.payline.Deductions">
              &nbsp;
              <span
                [ngClass]="{
                  'fst-italic':
                    (deduction.TemporaryAmount != null &&
                      deduction.TemporaryAmount != deduction.PermanentAmount) ||
                    (deduction.TemporaryRate != null &&
                      deduction.TemporaryRate != deduction.PermanentRate)
                }">
                {{ allocation.calculateDeduction(deduction) | number: '1.2-2' }}
              </span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
